module.exports = __webpack_public_path__ + "static/media/ola.7db49f0d.webp";